module.exports = __webpack_public_path__ + "static/media/ronda-jones-realtor-review-real-estate_160px.5d19a046.png";